// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"2b7f7b29","703":"2b7b71f1"}[chunkId] + ".chunk.js";
};